import ListUoms from "../../../../components/@products/uoms/ListUoms";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UomPage() {

    return (
        <ListUoms 
            routeType={routeTypes.admin}
        />
    )
}       